import React from 'react';
import {TableHead} from "@mui/material";
import TableRowHead from "../../../../components/WMS/List/TableRowHead";
import {FormattedMessage} from "react-intl";
import TableCellHead from "../../../../components/WMS/List/TableCellHead";

function Header() {

    return (
        <TableHead>
            <TableRowHead isDesktop>
                {[
                    'wms.missionList.header.name',
                    'wms.missionList.header.status',
                    'wms.missionList.header.createdAt',
                    'wms.missionList.header.updatedAt',
                    'wms.missionList.header.member',
                    'wms.missionList.header.action'
                ].map((columId) => (
                    <TableCellHead key={columId} variant={'head'}>
                        <FormattedMessage id={columId} />
                    </TableCellHead>
                ))}
            </TableRowHead>
        </TableHead>
    )
}

export default Header;